import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Snackbar } from '../components/snackbar';
import { LOADING, COMPLETE, BANKING_GET_BANKS_OK, BANKING_CREATE_BANK_OK, BANKING_UPDATE_BANK_OK, BANKING_DELETE_BANK_OK, SAVING } from './types';
import { call } from '../utilities/http';

const defaultState = {
    banks: undefined
};

/**
 * Banking state mapper.
 * @param {object} state
 * @param {string} action
 */
export default function(state = defaultState, action) {
    switch (action.type) {
        case BANKING_GET_BANKS_OK:
            return { ...state, banks: action.data };

        case BANKING_CREATE_BANK_OK:
            return { ...state, banks: state.banks ? [...state.banks, action.data] : [action.data] };

        case BANKING_UPDATE_BANK_OK:
            return { ...state, banks: state.banks ? [action.data, ...state.banks.filter(b => b.id !== action.data.id)] : [action.data] };
        case BANKING_DELETE_BANK_OK:
            const banks = state.banks.filter(b => b.id !== action.data.id);
            return { ...state, banks: [...banks] };

        default:
            return state;
    }
}

export function getBanks(role, onSuccess = (response, dispatch) => null) {
    let errorMessage = <FormattedMessage id={'error.getBanks'} defaultMessage={'Unable to retrieve banking details.'} />;
    const { id, type } = role;
    return async function(dispatch) {
        dispatch({ type: LOADING });
        call({ path: `/${type}/${id}/banks` })
            .then(response => {
                dispatch({ type: BANKING_GET_BANKS_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response, dispatch);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function createBankRecord(bank, role, onSuccess = (response, dispatch) => null) {
    let errorMessage = <FormattedMessage id={'error.getBanks'} defaultMessage={'Unable to create bank record.'} />;
    const { id, type } = role;

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/bank`, method: 'POST', body: { ...bank, ref_type: type, ref_id: id } })
            .then(response => {
                dispatch({ type: BANKING_CREATE_BANK_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response, dispatch);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}
export function deleteBankRecord(id, onSuccess = (response, dispatch) => null) {
    let errorMessage = <FormattedMessage id={'error.getBanks'} defaultMessage={'Unable to delete bank record.'} />;

    if (!id) {
        Snackbar.error(errorMessage);
        return;
    }

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/bank/${id}`, method: 'DELETE' })
            .then(response => {
                dispatch({ type: BANKING_DELETE_BANK_OK, data: { id } });
                dispatch({ type: COMPLETE });
                onSuccess(response, dispatch);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}

export function updateBankRecord(bank, role, onSuccess = (response, dispatch) => null) {
    let errorMessage = <FormattedMessage id={'error.getBanks'} defaultMessage={'Unable to update bank record.'} />;

    const { id, type } = role;
    if (!bank || !bank.id) {
        Snackbar.error(errorMessage);
        return;
    }

    return async function(dispatch) {
        dispatch({ type: SAVING });
        call({ path: `/bank/${bank.id}`, method: 'PUT', body: { ...bank, ref_type: type, ref_id: id } })
            .then(response => {
                dispatch({ type: BANKING_UPDATE_BANK_OK, data: response });
                dispatch({ type: COMPLETE });
                onSuccess(response, dispatch);
            })
            .catch(error => {
                Snackbar.error(errorMessage);
                dispatch({ type: COMPLETE });
            });
    };
}



// WEBPACK FOOTER //
// ./src/reducers/banking.jsx